import { FC, memo } from "react"
import { CurrencyDto, CurrencyType } from "."
import { IOption } from "../../../types"
import { CryptoItem } from "../CryptoItem"
import { ExchangeSelect } from "../ExchangeSelect"
import { FiatItem } from "../FiatItem"
import { SelectorButton } from "../SelectorButton"

type Props = {
  isMobile: boolean
  cryptoOptions: CurrencyType[]
  cryptoCurrency: CurrencyDto | null | undefined
  cryptoAmount: string
  onCryptoAmountChange: (amount: string) => void
  onCryptoCurrencyChange: (option: CurrencyDto) => void
  fiatOptions: CurrencyType[]
  fiatCurrency: CurrencyDto | null | undefined
  fiatAmount: string
  onFiatAmountChange: (amount: string) => void
  onFiatCurrencyChange: (option: CurrencyDto) => void
  onBuyClick: () => void
}

const BuyBlockComponent: FC<Props> = ({
  cryptoOptions,
  isMobile,
  cryptoCurrency,
  cryptoAmount,
  onCryptoAmountChange,
  onCryptoCurrencyChange,
  fiatOptions,
  fiatCurrency,
  fiatAmount,
  onBuyClick,
  onFiatAmountChange,
  onFiatCurrencyChange,
}) => {
  return (
    <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
      <div
        style={{
          display: "flex",
          gap: "16px",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <ExchangeSelect
          label={!isMobile ? "You Spend" : undefined}
          buttonTitle={({ isOpen }) => <SelectorButton isOpen={isOpen} code={fiatCurrency?.code ?? ""} name={fiatCurrency?.name ?? ""} />}
          inputValue={fiatAmount}
          onChangeInput={(x) => onFiatAmountChange(x.target.value)}
          // @ts-ignore
          onChange={(x) => onFiatCurrencyChange(x.meta)}
          dropDownStyle={{ overflowY: "auto" }}
          options={fiatOptions}
          renderOption={(option: IOption<string, { name: string; rate: number }>, optionProps) => (
            <FiatItem
              {...optionProps}
              isActive={option.value === fiatCurrency?.code}
              key={option.value}
              name={option.meta?.name ?? ""}
              currency={option.label}
            />
          )}
        />
        {!isMobile ? <span style={{ margin: "48px 0 0", fontSize: "16px", color: "#ffffff" }}>=</span> : null}
        <ExchangeSelect
          label={!isMobile ? "You Receive" : undefined}
          buttonTitle={({ isOpen }) => (
            <SelectorButton isOpen={isOpen} code={cryptoCurrency?.code ?? ""} name={cryptoCurrency?.name ?? ""} />
          )}
          inputValue={cryptoAmount}
          onChangeInput={(x) => onCryptoAmountChange(x.target.value)}
          // @ts-ignore
          onChange={(x) => onCryptoCurrencyChange(x.meta)}
          options={cryptoOptions}
          dropDownStyle={{ overflowY: "auto" }}
          renderOption={(option: IOption<string, { name: string; rate: number }>, optionProps) => (
            <CryptoItem
              {...optionProps}
              key={option.value}
              isActive={option.value === cryptoCurrency?.code}
              name={option.meta?.name ?? ""}
              currency={option.value}
            />
          )}
        />
      </div>

      {!isMobile ? (
        <button
          style={{
            border: "none",
            outline: "none",
            color: "#ffffff",
            height: "65px",
            borderRadius: "60px",
            padding: "0 34px",
            backgroundColor: "#E41E1F",
          }}
          onClick={onBuyClick}
        >
          Buy {cryptoCurrency?.code ?? ""}
        </button>
      ) : null}
    </div>
  )
}

export const BuyBlock = memo(BuyBlockComponent)
